class e {
  static ok(r) {
    return new u(r);
  }
  static err(r) {
    return new a(r);
  }
  static fromThrower(r) {
    try {
      return e.ok(r());
    } catch (t) {
      return e.err(t);
    }
  }
  static fromNullable(r, t, n) {
    return r != null ? e.ok(t(r)) : e.err(n());
  }
  static fromBool(r, t, n) {
    return r ? e.ok(t()) : e.err(n());
  }
}
class u extends e {
  value;
  constructor(r) {
    super(), this.value = r;
  }
  isOk() {
    return !0;
  }
  isErr() {
    return !1;
  }
  unwrap() {
    return this.value;
  }
  unwrapErr() {
    throw new Error("Cannot call unwrapErr on ok result");
  }
  unwrapOr(r) {
    return this.value;
  }
  unwrapOrElse(r) {
    return this.value;
  }
  map(r) {
    return new u(r(this.value));
  }
  mapErr(r) {
    return this;
  }
  andThen(r) {
    return r(this.value);
  }
  orElse(r) {
    return this;
  }
  and(r) {
    return r;
  }
  or(r) {
    return this;
  }
}
class a extends e {
  value;
  constructor(r) {
    super(), this.value = r;
  }
  unwrap() {
    throw new Error("Cannot call unwrap on err result");
  }
  unwrapErr() {
    return this.value;
  }
  isOk() {
    return !1;
  }
  isErr() {
    return !0;
  }
  unwrapOr(r) {
    return r;
  }
  unwrapOrElse(r) {
    return r();
  }
  map(r) {
    return this;
  }
  mapErr(r) {
    return new a(r(this.value));
  }
  andThen(r) {
    return this;
  }
  orElse(r) {
    return r(this.value);
  }
  and(r) {
    return this;
  }
  or(r) {
    return r;
  }
}
export {
  e as R
};
//# sourceMappingURL=result-BPlAbaTC.js.map
